/** @format */

import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useSelector } from "react-redux";
import { connect } from "react-redux";
import { Button, Modal } from "antd";
import SendQueryForm from "./../SendQueryForm/SendQueryForm";
import { accessToken } from "../../utils/accessToken";

function HomeModal({ visible, setVisible, userProfile, fullUserProfile }) {
  const [cookies, setCookie] = useCookies([""]);
  const [successQueryVisible, setSuccessQueryVisible] = useState(false);
  // const token = useSelector(
  //   (state) => state.appToken.token && state.appToken.token.access_token
  // );

  // let token = "";
  // if(localStorage.getItem('kcAccessToken')){
  //   token = localStorage.getItem('kcAccessToken');
  // }

  let token = '';
  token = accessToken();
  if(!token){
    token = process.env.NEXT_PUBLIC_ANONYMOUS_TOKEN;
  }
  
  useEffect(() => {
    token = accessToken();
    if(!token){
      token = process.env.NEXT_PUBLIC_ANONYMOUS_TOKEN;
    }
  }, []);
  
  let {
    firstName = "",
    lastName = "",
    orgName = "",
    profileType = "",
    profileId = "",
    email = "",
    country = "",
    orgPhone = "",
    whatsappNumber = "",
    recieveWhatsappMessage = ""
  } = fullUserProfile || {};

  let requesterName = firstName;
  if (lastName && lastName !== null) {
    requesterName = requesterName + " " + lastName;
  }

  let values = {
    profileId: profileId,
    profileType: profileType,
    category: "",
    requirementDetails: "",
    upload: {},
    quantity: "",
    pricePerItem: "",
    deliveryDate: "",
    requesterName: requesterName,
    companyName: orgName,
    emailId: email,
    country: country,
    city: "",
    mobileNo: orgPhone,
    whatsappNumber : whatsappNumber,
    whatsappConsent : recieveWhatsappMessage,
  };

  const sendQueryCancel = (status) => {
    if (status === "success") {
      setVisible(false);
      setSuccessQueryVisible(true);
    } else {
      setVisible(false);
    }
  };

  const successQueryCancel = () => {
    setSuccessQueryVisible(false);
  };

  return (
    <>
      <Modal
        visible={visible}
        footer={null}
        onCancel={sendQueryCancel}
        style={{ top: 5 }}
        bodyStyle={{ padding: "0" }}
        width={550}
        className="rfq-submit-modal"
      >
        <SendQueryForm
          sendQueryCancel={sendQueryCancel}
          token={token || process.env.NEXT_PUBLIC_ANONYMOUS_TOKEN}
          initialValues={values}
          userId={userProfile && userProfile.profileId}
          userProfile={userProfile}
        />
      </Modal>
      <Modal
        visible={successQueryVisible}
        footer={null}
        closable={true}
        onCancel={successQueryCancel}
        centered
        bodyStyle={{ padding: "0" }}
        width={400}
        className="rfq-submission-modal"
      >
        <div id="send-query-success-modal">
          <div className="send-query-success-modal-content">
            <p className="send-query-success-modal-para1">Thank you!</p>
            <p className="send-query-success-modal-para2">
              We have received your Sourcing request, and will revert within the
              next 48-72 hours.
            </p>
          </div>
          <Button
            className="send-query-success-modal-button"
            onClick={() => {
              successQueryCancel();
            }}
          >
            Back to home page
          </Button>
        </div>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    userProfile: state.userProfile.userProfile,
  };
};

export default connect(mapStateToProps, null)(HomeModal);
